const R = require('ramda');

const drawMegaminxLL = ({ colorScheme, state }) => {
  const color = getColor(colorScheme);
  const coloredState = R.map(color, state);

  return formatString(coloredState);
};

const getColor = ({ U, R: Right, F, L, Bl, Br }) =>
  R.cond([
    [R.equals(0), R.always(U)],
    [R.equals(1), R.always(F)],
    [R.equals(2), R.always(Right)],
    [R.equals(3), R.always(Br)],
    [R.equals(4), R.always(Bl)],
    [R.T, R.always(L)],
  ]);

const formatString = list =>
  R.reduce(
    R.flip(R.replace('{}')),
    `<svg xmlns="http://www.w3.org/2000/svg">
  <g stroke-linejoin="round">
    <polygon
      points="80.2229123600034,132.367048291092 68,94.7487921443737 100,71.4994312482022 132,94.7487921443737 119.777087639997,132.367048291092"
      stroke="#1E1E1E"
      stroke-width="4"
      fill="{}"
    />

    <polygon
      points="119.777087639997,132.367048291092 106.513112147391,173.19828709199 93.4868878526086,173.19828709199 80.2229123600034,132.367048291092"
      stroke="#1E1E1E"
      stroke-width="4"
      fill="{}"
    />
    <polygon
      points="119.777087639997,132.367048291092 162.708697210182,132.36980465773 149.442719099992,173.19828709199 106.513112147391,173.19828709199"
      stroke="#1E1E1E"
      stroke-width="4"
      fill="{}"
    />
    <polygon
      points="132,94.7487921443737 166.73402188981,119.981129159454 162.708697210182,132.36980465773 119.777087639997,132.367048291092"
      stroke="#1E1E1E"
      stroke-width="4"
      fill="{}"
    />
    <polygon
      points="132,94.7487921443737 145.26921841351,53.9192568717434 180,79.1526467251942 166.73402188981,119.981129159454"
      stroke="#1E1E1E"
      stroke-width="4"
      fill="{}"
    />
    <polygon
      points="100,71.4994312482022 134.73078158649,46.2626343382162 145.26921841351,53.9192568717434 132,94.7487921443737"
      stroke="#1E1E1E"
      stroke-width="4"
      fill="{}"
    />
    <polygon
      points="100,71.4994312482022 65.2692184135095,46.2626343382162 100,21.0292444847653 134.73078158649,46.2626343382162"
      stroke="#1E1E1E"
      stroke-width="4"
      fill="{}"
    />
    <polygon
      points="68,94.7487921443737 54.7307815864905,53.9192568717434 65.2692184135095,46.2626343382162 100,71.4994312482022"
      stroke="#1E1E1E"
      stroke-width="4"
      fill="{}"
    />
    <polygon
      points="68,94.7487921443737 33.2659781101904,119.981129159454 20,79.1526467251942 54.7307815864905,53.9192568717434"
      stroke="#1E1E1E"
      stroke-width="4"
      fill="{}"
    />
    <polygon
      points="80.2229123600034,132.367048291092 37.2913027898181,132.36980465773 33.2659781101904,119.981129159454 68,94.7487921443737"
      stroke="#1E1E1E"
      stroke-width="4"
      fill="{}"
    />
    <polygon
      points="80.2229123600034,132.367048291092 93.4868878526086,173.19828709199 50.5572809000084,173.19828709199 37.2913027898181,132.36980465773"
      stroke="#1E1E1E"
      stroke-width="4"
      fill="{}"
    />
    <polygon
      points="50.5572809000084,173.19828709199 38.1966011250105,190.211303259031 85.1671842700026,190.211303259031 93.4868878526086,173.19828709199"
      stroke="#1E1E1E"
      stroke-width="4"
      fill="{}"
    />

    <polygon
      points="106.513112147391,173.19828709199 93.4868878526086,173.19828709199 85.1671842700025,190.211303259031 114.832815729997,190.211303259031"
      stroke="#1E1E1E"
      stroke-width="4"
      fill="{}"
    />
    <polygon
      points="149.442719099992,173.19828709199 161.80339887499,190.211303259031 114.832815729997,190.211303259031 106.513112147391,173.19828709199"
      stroke="#1E1E1E"
      stroke-width="4"
      fill="{}"
    />
    <polygon
      points="149.442719099992,173.19828709199 161.80339887499,190.211303259031 176.318107302494,145.539624084803 162.708697210182,132.36980465773"
      stroke="#1E1E1E"
      stroke-width="4"
      fill="{}"
    />
    <polygon
      points="166.73402188981,119.981129159454 162.708697210182,132.36980465773 176.318107302494,145.539624084803 185.485291572496,117.325931974764"
      stroke="#1E1E1E"
      stroke-width="4"
      fill="{}"
    />
    <polygon
      points="180,79.1526467251942 200,72.6542528005361 185.485291572496,117.325931974764 166.73402188981,119.981129159454"
      stroke="#1E1E1E"
      stroke-width="4"
      fill="{}"
    />
    <polygon
      points="180,79.1526467251942 200,72.6542528005361 162,45.0456367363323 145.26921841351,53.9192568717434"
      stroke="#1E1E1E"
      stroke-width="4"
      fill="{}"
    />
    <polygon
      points="134.73078158649,46.2626343382162 145.26921841351,53.9192568717434 162,45.0456367363323 138,27.6086160642037"
      stroke="#1E1E1E"
      stroke-width="4"
      fill="{}"
    />
    <polygon
      points="100,21.0292444847653 100,0 138,27.6086160642037 134.73078158649,46.2626343382162"
      stroke="#1E1E1E"
      stroke-width="4"
      fill="{}"
    />
    <polygon
      points="100,21.0292444847653 100,0 62,27.6086160642037 65.2692184135095,46.2626343382162"
      stroke="#1E1E1E"
      stroke-width="4"
      fill="{}"
    />
    <polygon
      points="54.7307815864905,53.9192568717434 65.2692184135095,46.2626343382162 62,27.6086160642037 38,45.0456367363324"
      stroke="#1E1E1E"
      stroke-width="4"
      fill="{}"
    />
    <polygon
      points="20,79.1526467251942 0,72.6542528005361 38,45.0456367363324 54.7307815864905,53.9192568717434"
      stroke="#1E1E1E"
      stroke-width="4"
      fill="{}"
    />
    <polygon
      points="20,79.1526467251942 0,72.6542528005361 14.514708427504,117.325931974764 33.2659781101904,119.981129159454"
      stroke="#1E1E1E"
      stroke-width="4"
      fill="{}"
    />
    <polygon
      points="37.2913027898181,132.36980465773 33.2659781101904,119.981129159454 14.514708427504,117.325931974764 23.6818926975065,145.539624084803"
      stroke="#1E1E1E"
      stroke-width="4"
      fill="{}"
    />
    <polygon
      points="50.5572809000084,173.19828709199 38.1966011250105,190.211303259031 23.6818926975065,145.539624084803 37.2913027898181,132.36980465773"
      stroke="#1E1E1E"
      stroke-width="4"
      fill="{}"
    />
  </g>
</svg>`,
    list
  );

module.exports = {
  drawMegaminxLL,
};
